import { useState } from "react";
import { useToastify } from "../../../../../../Hooks/hooks";
import useLanguagesHooks from "../../../../../../Components/Languages/setLanguage-hooks";

const usePushSubscribe = (companyId: number, onClose: () => void) => {
    const { t } = useLanguagesHooks();
    const [loading, setLoading] = useState(false);
    const { showToastError, showToastSuccess } = useToastify();
    const token = localStorage.getItem("p_menu_token");
    const urlBase64ToUint8Array = (base64String: string) => {
        const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
        const rawData = window.atob(base64);
        return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
    };

    const handleSubscribe = async () => {
        if (!("PushManager" in window)) {
            showToastError("Push-уведомления недоступны в этом браузере или устройстве.");
            return;
        }
        if (!("serviceWorker" in navigator)) {
            showToastError("Ваш браузер не поддерживает сервис-воркеры (необходимы для уведомлений).");
            return;
        }

        setLoading(true);
        try {
            // 1️⃣ Регистрируем SW
            const registration = await navigator.serviceWorker.register("/sw.js");
            await navigator.serviceWorker.ready;

            // 2️⃣ Получаем public VAPID key с сервера
            const res = await fetch(`/api/company/${companyId}/vapid/`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Cache-Control": "no-cache",
                    "Accept": "application/json",
                },
            });
            if (!res.ok) {
                throw new Error(`${t('My_Business.Push_Sub.Error_1')} ${res.status}`);
            }
            const data = await res.json();
            const vapidPublicKey = data.vapid_public_key;

            // 3️⃣ Подписка
            const subscription = await registration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
            });

            // 4️⃣ Отправка подписки на сервер
            const subRes = await fetch(`/api/company/${companyId}/subscribe/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                  body: JSON.stringify({
                    subscription: subscription.toJSON(),
                    userAgent: navigator.userAgent,   
                }),
            });

            if (!subRes.ok) {
                throw new Error(`${t('My_Business.Push_Sub.Error_1')} ${subRes.status}`);
            }
            localStorage.setItem(`sub_${companyId}`, 'enabled')
            showToastSuccess(t('My_Business.Push_Sub.Success'));
            onClose();
        } catch (err) {
            console.error("Ошибка подписки:", err);
            showToastError(t('My_Business.Push_Sub.Error_2'));
        } finally {
            setLoading(false);
        }
    };

    const onReject = () => {
        localStorage.setItem(`sub_${companyId}`, 'rejected');
        onClose();
    };

    return {
        loading,
        onReject,
        handleSubscribe
    }
};

export default usePushSubscribe